import { Screen, TopBar, Logo, BackButton, ScrollArea, BottomBar } from "@/components/jk/ui";
import { ProgressBar } from "@/components/jk/kit";

/**
 * Shared shell for the 4-step onboarding flow.
 * Top bar (back + logo) · progress bar · step label · editorial heading · content · bottom CTA.
 */
const OnboardingShell = ({ step, title, subtitle, children, footer, onBack, testid }) => (
  <Screen testid={testid}>
    <TopBar left={<BackButton onClick={onBack} />} center={<Logo className="h-[16px] w-auto" />} />
    {step ? (
      <div className="px-6 pt-1">
        <ProgressBar value={step * 25} />
        <p className="mt-2 text-[12px] text-[#666666]">Step {step} of 4</p>
      </div>
    ) : (
      <div className="pt-3" />
    )}
    <ScrollArea className="px-6 pt-5">
      <h1 className="text-[30px] font-bold leading-[1.08] tracking-[-0.02em] text-[#111111]">{title}</h1>
      <p className="mt-2 text-[14px] leading-relaxed text-[#666666]">{subtitle}</p>
      <div className="mt-7 pb-6">{children}</div>
    </ScrollArea>
    <BottomBar>{footer}</BottomBar>
  </Screen>
);

export default OnboardingShell;
